import * as ActionTypes from "services/state/action-types";

const USAGE_INITIAL_STATE = {
  loading: false,
  error: false,
  usageData: [],
  usageProfileData: [],
};

export function usage(state = USAGE_INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.GET_USAGE_PROFILE:
    case ActionTypes.SEND_USAGES_BY_REPORT_TYPE:
      return { ...state, loading: true };

    case ActionTypes.SEND_USAGES_BY_REPORT_TYPE_SUCCESS:
      return { ...state, loading: false };

    case ActionTypes.GET_USAGE_PROFILE_FAIL:
    case ActionTypes.SEND_USAGES_BY_REPORT_TYPE_FAIL:
      return { ...state, loading: false, error: true };

    /*  Profiles consumption start   */
    case ActionTypes.GET_USAGE_PROFILE_SUCCESS:
      return { ...state, loading: false, usageProfileData: action.payload.data };
    /*  Profiles consumption end    */

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/state/usage/reducer.js